<div class="card m-0 bg-transparent">
  <div class="card-body">
    <div class="row">
      <form
        class="needs-validation"
        [formGroup]="stripeform"
        (ngSubmit)="onSubmit()"
      >
        <div class="row d-flex justify-content-between align-items-center mb-4">
          <div class="col-10 d-flex align-items-center">
            <h4
              class="card-title m-0 offcanvas-header-text d-flex align-items-center"
            >
              GooglePay Settings
              <!-- <i
                class="mdi mdi-information-outline font-size-16 ms-1"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="You can show or hide the foooter's component at the bottom of your Channel Posts"
              ></i> -->
            </h4>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 mb-3">
            <label
              for="merchantName"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              Merchant Name
            </label>
            <div
              class="input-group rounded-2 col-12 p-0 mb-2 offcanvas-border-primary"
              title="Using format option"
            >
              <input
                type="text"
                class="form-control input-lg border-0 offcanvas-primary"
                id="merchantName"
                formControlName="merchantName"
                [ngClass]="{
                  'is-invalid': submitted && f.merchantName.errors,
                }"
                placeholder="Enter merchant name"
              />
              <div
                *ngIf="submitted && f.merchantName.errors"
                class="invalid-feedback"
              >
                <div class="text-start" *ngIf="f.merchantName.errors.required">
                  merchantName Required
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mb-3">
            <label
              for="countryCode"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              Country
            </label>
            <select
              class="form-select offcanvas-primary offcanvas-border-primary"
              id="countryCode"
              formControlName="countryCode"
            >
              <ng-container *ngFor="let countrie of countries">
                <option [ngValue]="countrie.code">{{ countrie.name }}</option>
              </ng-container>
            </select>
          </div>
          <div class="col-12 mb-3">
            <label
              for="currencyCode"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              Currency
            </label>
            <select
              class="form-select offcanvas-primary offcanvas-border-primary"
              id="currencyCode"
              formControlName="currencyCode"
            >
              <ng-container *ngFor="let currency of currencies">
                <option [ngValue]="currency.code">{{ currency.name }}</option>
              </ng-container>
            </select>
          </div>
          <div class="col-12 mb-3">
            <label
              for="environment"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              Environment
            </label>
            <select
              class="form-select offcanvas-primary offcanvas-border-primary"
              id="environment"
              formControlName="environment"
            >
              <option [ngValue]="'TEST'">Test</option>
              <option [ngValue]="'PRODUCTION'">Production</option>
            </select>
          </div>
          <div *ngIf="gateway == 'stripe'" class="col-12 mb-3">
            <label
              for="merchantId"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              Stripe Publish Key
            </label>
            <div
              class="input-group rounded-2 col-12 p-0 mb-2 offcanvas-border-primary"
              title="Using format option"
            >
              <input
                type="text"
                class="form-control input-lg border-0 offcanvas-primary"
                id="stripe_publishableKey"
                formControlName="stripe_publishableKey"
                [ngClass]="{
                  'is-invalid': submitted && f.stripe_publishableKey.errors,
                }"
                placeholder="Enter Publish Key"
              />
              <div
                *ngIf="submitted && f.stripe_publishableKey.errors"
                class="invalid-feedback"
              >
                <div
                  class="text-start"
                  *ngIf="f.stripe_publishableKey.errors.required"
                >
                  stripe publishableKey Required
                </div>
              </div>
            </div>
            <div class="col-12 mb-3">
              <label
                for="apiKey"
                class="offcanvas-header-text w-100"
                style="text-align: left"
              >
                Stripe API Key
              </label>
              <div
                class="input-group rounded-2 col-12 p-0 mb-2 offcanvas-border-primary"
                title="Using format option"
              >
                <input
                  type="text"
                  class="form-control input-lg border-0 offcanvas-primary"
                  id="apiKey"
                  formControlName="api_key"
                  [ngClass]="{
                    'is-invalid': submitted && f.api_key.errors,
                  }"
                  placeholder="Enter API Key"
                />
                <div
                  *ngIf="submitted && f.api_key.errors"
                  class="invalid-feedback"
                >
                  <div class="text-start" *ngIf="f.api_key.errors.required">
                    API Key Required
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 mb-3">
              <label
                for="apiBaseURL"
                class="offcanvas-header-text w-100"
                style="text-align: left"
              >
                Stripe Webhook Secret
              </label>
              <div
                class="input-group rounded-2 col-12 p-0 mb-2 offcanvas-border-primary"
                title="Using format option"
              >
                <input
                  type="text"
                  class="form-control input-lg border-0 offcanvas-primary"
                  id="apiBaseURL"
                  formControlName="webhook_secret"
                  [ngClass]="{
                    'is-invalid': submitted && f.webhook_secret.errors,
                  }"
                  placeholder="Enter API URL"
                />
                <div
                  *ngIf="submitted && f.webhook_secret.errors"
                  class="invalid-feedback"
                >
                  <div
                    class="text-start"
                    *ngIf="f.webhook_secret.errors.required"
                  >
                    Webhook Secret Required
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            *ngIf="gateway == 'braintree' || gateway == 'adyen'"
            class="col-12 mb-3"
          >
            <label
              for="merchantId"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              Merchant ID
            </label>
            <div
              class="input-group rounded-2 col-12 p-0 mb-2 offcanvas-border-primary"
              title="Using format option"
            >
              <input
                type="text"
                class="form-control input-lg border-0 offcanvas-primary"
                id="merchantId"
                formControlName="merchantId"
                [ngClass]="{
                  'is-invalid': submitted && f.merchantId.errors,
                }"
                placeholder="Enter merchant ID"
              />
              <div
                *ngIf="submitted && f.merchantId.errors"
                class="invalid-feedback"
              >
                <div class="text-start" *ngIf="f.merchantId.errors.required">
                  merchantId Required
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="gateway == 'braintree'" class="col-12 mb-3">
            <label
              for="clientKey"
              class="offcanvas-header-text w-100"
              style="text-align: left"
            >
              Client Key
            </label>
            <div
              class="input-group rounded-2 col-12 p-0 mb-2 offcanvas-border-primary"
              title="Using format option"
            >
              <input
                type="text"
                class="form-control input-lg border-0 offcanvas-primary"
                id="clientKey"
                formControlName="clientKey"
                [ngClass]="{
                  'is-invalid': submitted && f.clientKey.errors,
                }"
                placeholder="Enter merchant ID"
              />
              <div
                *ngIf="submitted && f.clientKey.errors"
                class="invalid-feedback"
              >
                <div class="text-start" *ngIf="f.clientKey.errors.required">
                  clientKey Required
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="d-flex justify-content-between">
            <button type="submit" class="btn btn-success w-md ms-auto">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
